







import { IClient } from "@/models/clients";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "client-login": () =>
      import(
        "@/components/app/global/client/settings/clientDetails/clientLogin.vue"
      )
  }
})
export default class ClientSettingsView extends Vue {
  public get clientId(): IClient["id"] {
    return this.$route.params.clientId;
  }
}
